import { Route, Redirect } from 'react-router-dom';
import AuthenticatedRoute from '../../components/Routes/AuthenticatedRoute';
import { ROUTES } from '../../routing';
import Companies from '../../pages/Admin/Companies';
import AdminHome from '../../pages/Admin/AdminHome';
import Learners from '../../pages/Admin/Learners';
import Cohorts from '../../pages/Admin/Cohorts';
import Mentors from '../../pages/Admin/Mentors';
import AssessmentTesters from '../../pages/Admin/AssessmentTesters';
import AssessmentTestsResults from '../../pages/Admin/AssessmentTestsResults';
import CompanySettings from '../../pages/Admin/Settings';
import Progress from '../../pages/Admin/Progress';
import SOSQuestions from '../../pages/Admin/SOSQuestions';
import ReplyToSOSQuestion from '../../pages/Admin/ReplyToSOSQuestion';
import OfficeHours from '../../pages/Admin/OfficeHours';
import SubcohortOfficeHour from '../../pages/Admin/SubcohortOfficeHour';
import CompanyProjects from '../../pages/Admin/CompanyProjects';
import CompanyProjectSubmissionPage from '../../pages/Admin/CompanyProjectSubmission';
import AssessmentTestResult from '../../pages/Admin/AssessmentTestResult';
import AssessmentTestGuard from '../../components/Admin/AssessmenTest/AssessmentTestGuard';
import CMSPreviewModule from '../../pages/Admin/CMS/CMSPreviewModule';
import CMSPreviewModuleActivity from '../../pages/Admin/CMS/CMSPreviewModuleActivity';
import CMSPreviewProject from '../../pages/Admin/CMS/CMSPreviewProject';
import ModulesList from '../../pages/Admin/CMS/ModulesList';
import ModuleEditor from '../../pages/Admin/CMS/ModuleEditor';
import ProjectsList from '../../pages/Admin/CMS/ProjectsList';
import ProjectEditor from '../../pages/Admin/CMS/ProjectEditor';
import AssessmentTestsList from '../../pages/Admin/CMS/AssessmentTestsList';
import AssessmentTestEditor from '../../pages/Admin/CMS/AssessmentTestEditor';
import CMSPreviewAssessmentTest from '../../pages/Learner/AssessmentTest/CMSPreviewAssessmentTest';

export const ADMIN_ROUTES = [
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.HOME.PATH}
    key={ROUTES.ADMIN.HOME.PATH}
  >
    <AdminHome />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.COMPANIES.PATH}
    key={ROUTES.ADMIN.COMPANIES.PATH}
  >
    <Companies />
  </AuthenticatedRoute>,
  <Route
    key={ROUTES.ADMIN.COMPANY.PATH}
    exact
    path={ROUTES.ADMIN.COMPANY.PATH}
    render={(props) => (
      <Redirect
        to={ROUTES.ADMIN.PROGRESS.getPath({
          companyId: props.match.params.id ?? 'unknown',
        })}
      />
    )}
  />,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.LEARNERS.PATH}
    key={ROUTES.ADMIN.LEARNERS.PATH}
  >
    <Learners />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.COHORTS.PATH}
    key={ROUTES.ADMIN.COHORTS.PATH}
  >
    <Cohorts />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.MENTORS.PATH}
    key={ROUTES.ADMIN.MENTORS.PATH}
  >
    <Mentors />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.ASSESSMENT_TESTERS.PATH}
    key={ROUTES.ADMIN.ASSESSMENT_TESTERS.PATH}
  >
    <AssessmentTestGuard>
      <AssessmentTesters />
    </AssessmentTestGuard>
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.ASSESSMENT_TEST_RESULTS.PATH}
    key={ROUTES.ADMIN.ASSESSMENT_TEST_RESULTS.PATH}
  >
    <AssessmentTestGuard>
      <AssessmentTestsResults />
    </AssessmentTestGuard>
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.ASSESSMENT_TEST_RESULT.PATH}
    key={ROUTES.ADMIN.ASSESSMENT_TEST_RESULT.PATH}
  >
    <AssessmentTestGuard>
      <AssessmentTestResult />
    </AssessmentTestGuard>
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.SETTINGS.PATH}
    key={ROUTES.ADMIN.SETTINGS.PATH}
  >
    <CompanySettings />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.PROGRESS.PATH}
    key={ROUTES.ADMIN.PROGRESS.PATH}
  >
    <Progress />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.SOS_QUESTIONS.PATH}
    key={ROUTES.ADMIN.SOS_QUESTIONS.PATH}
  >
    <SOSQuestions />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.REPLY_TO_SOS_QUESTION.PATH}
    key={ROUTES.ADMIN.REPLY_TO_SOS_QUESTION.PATH}
  >
    <ReplyToSOSQuestion />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.OFFICE_HOURS.PATH}
    key={ROUTES.ADMIN.OFFICE_HOURS.PATH}
  >
    <OfficeHours />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.OFFICE_HOURS_SUBCOHORT.PATH}
    key={ROUTES.ADMIN.OFFICE_HOURS_SUBCOHORT.PATH}
  >
    <SubcohortOfficeHour />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.COMPANY_PROJECTS.PATH}
    key={ROUTES.ADMIN.COMPANY_PROJECTS.PATH}
  >
    <CompanyProjects />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.COMPANY_PROJECT_SUBMISSION.PATH}
    key={ROUTES.ADMIN.COMPANY_PROJECT_SUBMISSION.PATH}
  >
    <CompanyProjectSubmissionPage />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_MODULE_PREVIEW.PATH}
    key={ROUTES.ADMIN.CMS_MODULE_PREVIEW.PATH}
  >
    <CMSPreviewModule />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_MODULE_PREVIEW_ACTIVITY.PATH}
    key={ROUTES.ADMIN.CMS_MODULE_PREVIEW_ACTIVITY.PATH}
  >
    <CMSPreviewModuleActivity />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_PROJECT_PREVIEW.PATH}
    key={ROUTES.ADMIN.CMS_PROJECT_PREVIEW.PATH}
  >
    <CMSPreviewProject />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_MODULES.PATH}
    key={ROUTES.ADMIN.CMS_MODULES.PATH}
  >
    <ModulesList />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_MODULE_CREATE.PATH}
    key={ROUTES.ADMIN.CMS_MODULE_CREATE.PATH}
  >
    <ModuleEditor />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_MODULE_EDIT.PATH}
    key={ROUTES.ADMIN.CMS_MODULE_EDIT.PATH}
  >
    <ModuleEditor />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_PROJECTS.PATH}
    key={ROUTES.ADMIN.CMS_PROJECTS.PATH}
  >
    <ProjectsList />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_PROJECT_CREATE.PATH}
    key={ROUTES.ADMIN.CMS_PROJECT_CREATE.PATH}
  >
    <ProjectEditor />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_PROJECT_EDIT.PATH}
    key={ROUTES.ADMIN.CMS_PROJECT_EDIT.PATH}
  >
    <ProjectEditor />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_ASSESSMENT_TESTS.PATH}
    key={ROUTES.ADMIN.CMS_ASSESSMENT_TESTS.PATH}
  >
    <AssessmentTestsList />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_ASSESSMENT_TEST_CREATE.PATH}
    key={ROUTES.ADMIN.CMS_ASSESSMENT_TEST_CREATE.PATH}
  >
    <AssessmentTestEditor />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_ASSESSMENT_TEST_EDIT.PATH}
    key={ROUTES.ADMIN.CMS_ASSESSMENT_TEST_EDIT.PATH}
  >
    <AssessmentTestEditor />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.ADMIN.CMS_ASSESSMENT_TEST_PREVIEW.PATH}
    key={ROUTES.ADMIN.CMS_ASSESSMENT_TEST_PREVIEW.PATH}
  >
    <CMSPreviewAssessmentTest />
  </AuthenticatedRoute>,
];
